module.exports = __webpack_public_path__ + "static/media/ug.e70ae26e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/ug.png
// module id = 2009
// module chunks = 0